import { Label } from "@workspace/ui/components/label"
import { Textarea } from "@workspace/ui/components/textarea"

/**
 * Optional per-item note ("special instructions") rendered inside every
 * add-to-cart `<form>` (standard modifier customizer + the pizza / meal-deal /
 * free-option builders). Plain uncontrolled `<textarea name="specialInstructions">`
 * — the add Server Action reads it off `FormData` (`readSpecialInstructions`)
 * and stores it on the cart line, so this needs no client state and keeps the
 * builders working without JS. Always optional; capped at 200 chars to match
 * the contract's `CartLineInput.specialInstructions` limit.
 *
 * `form` associates it with a form it doesn't sit inside (the native `form`
 * attribute — still no JS), for builders that keep the note out of their
 * sticky action bar.
 */
const MAX_LENGTH = 200

export function SpecialInstructionsField({
  label,
  placeholder,
  id = "special-instructions",
  form,
}: {
  label: string
  placeholder?: string
  id?: string
  /** Id of the add-to-cart `<form>` when the field renders outside it. */
  form?: string
}) {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Textarea
        id={id}
        name="specialInstructions"
        form={form}
        placeholder={placeholder}
        maxLength={MAX_LENGTH}
        rows={2}
      />
    </div>
  )
}
